import { useAppStore } from '@/store/appStore'
import { useSharedCustomViewsEnabled } from '@/hooks/useSharedCustomViewsEnabled'
import { isOwnedView } from '@/utils/customViews'
import type { ApiCustomView } from '@/types/api'

/**
 * The selected custom view when it carries shared notes: one the caller received, or one of their
 * own that is shared with someone. A private view has no audience, so it shows personal notes only.
 */
export function useActiveSharedView(): ApiCustomView | null {
  const selectedCustomViewId = useAppStore((s) => s.selectedCustomViewId)
  const customViews = useAppStore((s) => s.customViews)
  const sharingEnabled = useSharedCustomViewsEnabled()

  if (!sharingEnabled || selectedCustomViewId === null) return null
  const view = customViews.find((cv) => cv.id === selectedCustomViewId)
  if (!view) return null
  if (!isOwnedView(view)) return view
  return (view.shareCount ?? 0) > 0 ? view : null
}
